import React from 'react';
import HomeContainer from '@src/containers/Home';

const Home = () => <HomeContainer />;

export default Home;
